/**
 * Merge an editor-side `properties` patch over the live `cell.data.properties`
 * object so that fields the editor doesn't know about (notably relationship
 * keys defined by the template's `relationTypes`, which live OUTSIDE
 * `type.properties`) are preserved.
 *
 * Background:
 *   `PropertyEditor` builds `customProperties` from `type.properties.*` only.
 *   Naively writing `data.properties = customProperties` back drops every
 *   key that isn't represented in the editor view — for example,
 *   `linkedCctvIds`, `linkedReaderId`, etc. That is what caused user-created
 *   relationships to silently disappear when any other field on the same
 *   object was edited.
 *
 *   `mergeCellProperties` takes the current persisted properties and the
 *   editor's view, and returns a single object where the editor view wins
 *   for keys it knows about while everything else is carried over intact.
 *
 * Pure function — extracted so the merge semantics can be unit-tested
 * without instantiating React + JointJS.
 */
export type CellProperties = Record<string, unknown>

export function mergeCellProperties(
  current: CellProperties | null | undefined,
  editorView: CellProperties | null | undefined,
): CellProperties {
  return {
    ...(current ?? {}),
    ...(editorView ?? {}),
  }
}
